import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useState } from "react";
import { auth } from "../firebase.ts";

export function SignIn() {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function doSignIn() {
    setBusy(true);
    setError(null);
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });
    try {
      await signInWithPopup(auth, provider);
    } catch (e) {
      setError((e as Error)?.message ?? "sign_in_failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="signin-card">
      <div className="signin-brand">
        <span className="brand-mark" aria-hidden="true" />
        <span className="brand-name">Expat Admin</span>
      </div>
      <h2>Sign in to continue</h2>
      <p>
        Use the Google account on the admin allowlist. Access is enforced
        server-side; everyone else gets a no-access page.
      </p>
      {error && <div className="banner error">{error}</div>}
      <button
        type="button"
        className="luna-btn luna-btn-primary luna-btn-lg"
        onClick={doSignIn}
        disabled={busy}
      >
        {busy ? "Signing in…" : "Sign in with Google"}
      </button>
      <div className="signin-footer">
        admin · <code>expat-api</code>
      </div>
    </div>
  );
}
